import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    //获取店铺信息列表
    GET_SHOP_INFO(data) {
        controller='Stat';
        action='getDayStat';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_SHOP_INFO", data: data }); 
    },

    //获取小程序24小时流量信息
    GET_STAT_FLOW_HOURS_INFO(data) {
        controller='Stat';
        action='getDayFlowStat';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", act: "GET_SHOP_INFO", data: data }); 
    },

}